import { useSignal } from "@preact/signals-react";

import ModalReport from "componentsv2/modal/ModalReport";
import ModalAction from "componentsv2/modal/ModalAction";
import Popover from "componentsv2/widgets/Popover";
import ItemMenu from "componentsv2/menu/ItemMenu";
import { useWizard } from "storev2/wizardStore";
import proxy from "api/proxy";
import funcs from "tools/functions";
import { getStorage } from "store/local";

const session = getStorage("ctxSession");

function ButtonMenu({ type, title, record, values, Icon }) {
  const activeAction = useSignal(null);
  const showPop = useSignal(false);
  const openModal = useSignal(false);
  console.log("values ? ", type, title, record, values);

  async function onClick(value) {
    activeAction.value = value;
    if (type === "report") {
      if (!value.send_print) {
        await useWizard.getState().newRecord(value.layout);
        openModal.value = true;
      } else {
        await printDirectReport(value);
      }
    } else {
      console.log("Abriendo modal............");
      openModal.value = true;
      // type === 'action
      // if (value.layout) {
      // }
    }
  }

  async function printDirectReport(report) {
    const { reportUrl, nameFile } = await proxy.report({
      report: report.name,
      data: {
        company: session.company,
      },
      records: [record?.id],
    });
    funcs.createReportLink(reportUrl, nameFile);
  }

  function onClose() {
    openModal.value = false;
  }

  let Modal = type === "report" ? ModalReport : ModalAction;

  const Component = activeAction.value?.Component;
  console.log("REnder button menu", activeAction.value, openModal.value);
  return (
    <div className="overflow-visible">
      <button
        type="button"
        onClick={() => (showPop.value = true)}
        className="flex border border-neutral-300 shadow-md w-full md:w-32 h-11 items-center text-center bg-neutral-50 py-2 px-3 text-neutral-600 rounded-xl hover:bg-neutral-200"
      >
        <span className="ml-auto mr-3 my-auto text-sm">{title}</span>
        <Icon className="mr-auto h-6 w-6 my-auto fill-current text-neutral-500" />
      </button>
      <Popover show={showPop} trigger="hover">
        {values.map((value) => (
          <ItemMenu
            key={value}
            value={value}
            handleClick={onClick}
            type={type}
          />
        ))}
      </Popover>
      {openModal.value && (
        <Modal
          onClose={onClose}
          open={openModal}
          layout={activeAction.value?.layout}
          Component={Component}
        />
      )}
    </div>
  );
}

export default ButtonMenu;
